module.exports = "<symbol id=\"tt-icon-write\" viewBox=\"0 0 24 24\"><path d=\"M22.39 1.61a4.74 4.74 0 0 0-6.71 0L2.24 15a1.5 1.5 0 0 0-.31.54L.25 22.32a1.18 1.18 0 0 0 .31 1.12 1.18 1.18 0 0 0 1.12.31l6.72-1.68a1.49 1.49 0 0 0 .54-.31H9L22.39 8.32a4.75 4.75 0 0 0 0-6.71zm-7.55 4.18l3.37 3.37-10.09 10.1-3.37-3.38zM3 21l.7-2.8 2.1 2.1zM20.73 3.27a2.45 2.45 0 0 1 0 3.37l-.85.85-3.37-3.37.85-.85a2.44 2.44 0 0 1 3.37 0z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/search-page/write.svg
// module id = 447
// module chunks = 11